import React, { useEffect } from "react";
import { FiAlertCircle } from "react-icons/fi";

export const isErrorToastMessage = (message) => {
  const text = String(message || "").trim();
  if (!text) {
    return false;
  }

  return /(^no\s|error|failed|could not|cannot|can't|unable|unavailable|not available|only available|not allowed|not configured|required|must\b|missing|expired|forbidden|denied|invalid|locked|larger than|only .* can|can only|not found|try again|went wrong|conflict|^select\b|^attach\b)/i.test(text);
};

const Toast = ({ message, onClose }) => {
  const visible = isErrorToastMessage(message);

  useEffect(() => {
    if (!visible || !onClose) {
      return undefined;
    }

    const timer = window.setTimeout(onClose, 5000);
    return () => window.clearTimeout(timer);
  }, [message, onClose, visible]);

  if (!visible) {
    return null;
  }

  return (
    <div className="new-hrm-toast new-hrm-toast--error" role="alert">
      <FiAlertCircle aria-hidden="true" />
      <span>{message}</span>
      <button type="button" onClick={onClose} aria-label="Close message">
        Close
      </button>
    </div>
  );
};

export default Toast;
